import { useEffect } from 'react'
import PropTypes from 'prop-types'
import usePrev from '@utils/usePrev'
import { useFormContext } from '@context/FormContext'

const FormEffect = ({ onChange }) => {
  const { values } = useFormContext()
  const prevValues = usePrev(values)

  useEffect(() => {
    // Do not run effect on form init and only when an onChange prop is passed
    if (prevValues && onChange) {
      onChange({ prevValues, nextValues: values })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]) // Only depend on values, not onChange or prevValues

  return null
}

FormEffect.propTypes = {
  onChange: PropTypes.func.isRequired,
}

export default FormEffect

